export default __webpack_public_path__ + "static/ambc-16abaf219b01438b8a5047d2e4f0df5d.jpg";